import { css, styled } from "goober";
import {
  desktopViewportFrameCss,
  useDesktopViewportScale,
} from "../../hooks/useDesktopViewport";
import { CircleMesh } from "../CircleMesh";
import { HtmlViewer } from "../HtmlViewer";

const StyledHtml = styled("div")`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;

const bleedCss = (bleed: number) => css`
  margin: -${bleed}px;
  width: calc(100% + ${bleed * 2}px);
  height: calc(100% + ${bleed * 2}px);
`;

const Background = styled("div")`
  position: absolute;
  inset: 0;
`;

const PreviewContainer = styled("div")`
  position: relative;
  z-index: 1;
  width: 80%;
  max-width: 600px;
  aspect-ratio: 4 / 3;
  border-radius: 12px;
  outline: 0.5px solid var(--border-alpha);
  box-shadow: var(--elevation-low);
  overflow: hidden;
`;

const frame = css`
  ${desktopViewportFrameCss}
  display: block;
  border: none;
  background: transparent;
`;

type Props = {
  output: string;
  bleed?: number;
  baseRoute?: string;
};

export function Html({ output, bleed, baseRoute }: Props) {
  const previewContainerRef = useDesktopViewportScale<HTMLDivElement>();

  return (
    <StyledHtml className={bleed ? bleedCss(bleed) : undefined}>
      <Background>
        <CircleMesh mutingIntensity={1} seed="html-preview" />
      </Background>
      <PreviewContainer ref={previewContainerRef}>
        <HtmlViewer html={output} className={frame} baseRoute={baseRoute} />
      </PreviewContainer>
    </StyledHtml>
  );
}
